import { Link } from "react-router-dom";
import { CONTACT } from "../lib/site";
import { MapPin, Phone, Mail, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative bg-navy text-bg overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 grain pointer-events-none opacity-40"/>
      <div className="relative mx-auto max-w-[1440px] px-6 md:px-10 pt-24 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <div className="overline text-gold">Haveli Braj Bhushanjee · A Heritage Hotel &amp; Museum</div>
            <h3 className="font-display text-4xl md:text-5xl mt-4 leading-[1.05]">
              Where the past still lives on.
            </h3>
            <p className="mt-5 text-bg/70 text-sm leading-relaxed max-w-md">
              A 250-year-old heritage haveli in the heart of Bundi, run by the Bohara Braj Bhushanjee family — the same family that gave Bundi four Prime Ministers in the 19th century.
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <div className="overline text-gold mb-4">Explore</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="hover:text-terracotta transition-colors">The Haveli</Link></li>
              <li><Link to="/about" className="hover:text-terracotta transition-colors">About &amp; Museum</Link></li>
              <li><Link to="/heritage-hotel" className="hover:text-terracotta transition-colors">Rooms &amp; Tariff</Link></li>
              <li><Link to="/gallery" className="hover:text-terracotta transition-colors">Gallery</Link></li>
              <li><Link to="/heritage-hotel#booking" className="hover:text-terracotta transition-colors">Reserve</Link></li>
              <li><a href="https://www.kiplingsbundi.com/brochure.pdf" target="_blank" rel="noreferrer" className="hover:text-terracotta transition-colors" data-testid="footer-brochure">Download Brochure ↗</a></li>
              <li><a href="https://www.kiplingsbundi.com/bundi.htm" target="_blank" rel="noreferrer" className="hover:text-terracotta transition-colors" data-testid="footer-bundi">Bundi — Places to Visit ↗</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="overline text-gold mb-4">Contact</div>
            <ul className="space-y-3 text-sm text-bg/85">
              <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-gold shrink-0"/><span>{CONTACT.address}</span></li>
              <li className="flex items-center gap-3"><Phone size={16} className="text-gold shrink-0"/><span><a href={`tel:${CONTACT.phone.replace(/\s+/g,'')}`} className="hover:text-terracotta">{CONTACT.phone}</a> · <a href={`tel:${CONTACT.phone2.replace(/\s+/g,'')}`} className="hover:text-terracotta">{CONTACT.phone2}</a></span></li>
              <li className="flex items-center gap-3"><MessageCircle size={16} className="text-gold shrink-0"/><a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer" className="hover:text-terracotta" data-testid="footer-whatsapp">WhatsApp</a></li>
              <li className="flex items-center gap-3"><Mail size={16} className="text-gold shrink-0"/><a href={`mailto:${CONTACT.email}`} className="hover:text-terracotta">{CONTACT.email}</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-bg/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-bg/50">
          <div>© {new Date().getFullYear()} Haveli Braj Bhushanjee (A Heritage Hotel &amp; Museum) · Bundi, Rajasthan</div>
          <div>A family heritage home · Reserve direct for the best rate.</div>
        </div>
      </div>
    </footer>
  );
}
